export default __webpack_public_path__ + "static/media/1727.d76a0826.png";